unit View.data_base.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils;

type
  TFViewdata_baseList = class(TForm)
    btNew: TButton;
    data_baseDataset: TXDataWebDataSet;
    data_baseDatasetid: TIntegerField;
    data_baseDatasettoken: TStringField;
    data_baseDatasetfiscal: TBooleanField;
    data_baseDatasetaliado_id: TIntegerField;
    data_baseDatasetexcluido: TBooleanField;
    data_baseDatasetinclusao: TDateTimeField;
    data_baseDatasetalteracao: TDateTimeField;
    data_baseDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    data_baseDatasetrazao_social: TStringField;
    data_baseDatasetnome_fantasia: TStringField;
    data_baseDatasethost: TStringField;
    data_baseDatasetpath: TStringField;
    data_baseDatasetdata_base_multiempresa: TBooleanField;
    data_baseDatasetdata_base_empresa_destino: TBooleanField;
    data_baseDatasetversao_atual: TStringField;
    data_baseDatasetversao_pendente: TStringField;
    data_baseDatasetregime_contabil: TStringField;
    data_baseDatasetcontador_id: TIntegerField;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewdata_baseList: TFViewdata_baseList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewdata_baseList }

procedure TFViewdata_baseList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewdata_baseList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewdata_baseList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewdata_baseList, AElementID, Result, @AfterCreate);
end;

procedure TFViewdata_baseList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewdata_baseList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewdata_baseList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      data_baseDataset.Connection.Model.DefaultSchema.FindEntityType(data_baseDataset.EntitySetName),
      data_baseDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewdata_baseList.WebFormCreate(Sender: TObject);
begin
  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    data_baseDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewdata_baseList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.data_base.list.pagination.info');
  btNew := TButton.Create('view.data_base.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.data_base.list.table');
  cbPageSize := TComboBox.Create('view.data_base.list.cbPageSize');
  edSearch := TEdit.Create('view.data_base.list.search');
  lcPaginator := TListControl.Create('view.data_base.list.pagination');
  data_baseDataset := TXDataWebDataSet.Create(Self);
  data_baseDatasetid := TIntegerField.Create(Self);
  data_baseDatasettoken := TStringField.Create(Self);
  data_baseDatasetfiscal := TBooleanField.Create(Self);
  data_baseDatasetaliado_id := TIntegerField.Create(Self);
  data_baseDatasetexcluido := TBooleanField.Create(Self);
  data_baseDatasetinclusao := TDateTimeField.Create(Self);
  data_baseDatasetalteracao := TDateTimeField.Create(Self);
  data_baseDatasetexclusao := TDateTimeField.Create(Self);
  data_baseDatasetrazao_social := TStringField.Create(Self);
  data_baseDatasetnome_fantasia := TStringField.Create(Self);
  data_baseDatasethost := TStringField.Create(Self);
  data_baseDatasetpath := TStringField.Create(Self);
  data_baseDatasetdata_base_multiempresa := TBooleanField.Create(Self);
  data_baseDatasetdata_base_empresa_destino := TBooleanField.Create(Self);
  data_baseDatasetversao_atual := TStringField.Create(Self);
  data_baseDatasetversao_pendente := TStringField.Create(Self);
  data_baseDatasetregime_contabil := TStringField.Create(Self);
  data_baseDatasetcontador_id := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  data_baseDataset.BeforeLoadDFMValues;
  data_baseDatasetid.BeforeLoadDFMValues;
  data_baseDatasettoken.BeforeLoadDFMValues;
  data_baseDatasetfiscal.BeforeLoadDFMValues;
  data_baseDatasetaliado_id.BeforeLoadDFMValues;
  data_baseDatasetexcluido.BeforeLoadDFMValues;
  data_baseDatasetinclusao.BeforeLoadDFMValues;
  data_baseDatasetalteracao.BeforeLoadDFMValues;
  data_baseDatasetexclusao.BeforeLoadDFMValues;
  data_baseDatasetrazao_social.BeforeLoadDFMValues;
  data_baseDatasetnome_fantasia.BeforeLoadDFMValues;
  data_baseDatasethost.BeforeLoadDFMValues;
  data_baseDatasetpath.BeforeLoadDFMValues;
  data_baseDatasetdata_base_multiempresa.BeforeLoadDFMValues;
  data_baseDatasetdata_base_empresa_destino.BeforeLoadDFMValues;
  data_baseDatasetversao_atual.BeforeLoadDFMValues;
  data_baseDatasetversao_pendente.BeforeLoadDFMValues;
  data_baseDatasetregime_contabil.BeforeLoadDFMValues;
  data_baseDatasetcontador_id.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewdata_baseList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'token';
      Title := 'token';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fiscal';
      Title := 'fiscal';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'razao_social';
      Title := 'razao_social';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome_fantasia';
      Title := 'nome_fantasia';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'host';
      Title := 'host';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'path';
      Title := 'path';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_multiempresa';
      Title := 'data_base_multiempresa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_empresa_destino';
      Title := 'data_base_empresa_destino';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'versao_atual';
      Title := 'versao_atual';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'versao_pendente';
      Title := 'versao_pendente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'regime_contabil';
      Title := 'regime cont'#225'bil';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'contador_id';
      Title := 'C'#243'd. Contador';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    data_baseDataset.SetParentComponent(Self);
    data_baseDataset.Name := 'data_baseDataset';
    data_baseDataset.EntitySetName := 'data_base';
    data_baseDataset.Connection := DMConnection.ApiConnection;
    data_baseDataset.Left := 72;
    data_baseDataset.Top := 144;
    data_baseDatasetid.SetParentComponent(data_baseDataset);
    data_baseDatasetid.Name := 'data_baseDatasetid';
    data_baseDatasetid.FieldName := 'id';
    data_baseDatasetid.Required := True;
    data_baseDatasettoken.SetParentComponent(data_baseDataset);
    data_baseDatasettoken.Name := 'data_baseDatasettoken';
    data_baseDatasettoken.FieldName := 'token';
    data_baseDatasettoken.Required := True;
    data_baseDatasettoken.Size := 256;
    data_baseDatasetfiscal.SetParentComponent(data_baseDataset);
    data_baseDatasetfiscal.Name := 'data_baseDatasetfiscal';
    data_baseDatasetfiscal.FieldName := 'fiscal';
    data_baseDatasetfiscal.Required := True;
    data_baseDatasetaliado_id.SetParentComponent(data_baseDataset);
    data_baseDatasetaliado_id.Name := 'data_baseDatasetaliado_id';
    data_baseDatasetaliado_id.FieldName := 'aliado_id';
    data_baseDatasetaliado_id.Required := True;
    data_baseDatasetexcluido.SetParentComponent(data_baseDataset);
    data_baseDatasetexcluido.Name := 'data_baseDatasetexcluido';
    data_baseDatasetexcluido.FieldName := 'excluido';
    data_baseDatasetinclusao.SetParentComponent(data_baseDataset);
    data_baseDatasetinclusao.Name := 'data_baseDatasetinclusao';
    data_baseDatasetinclusao.FieldName := 'inclusao';
    data_baseDatasetalteracao.SetParentComponent(data_baseDataset);
    data_baseDatasetalteracao.Name := 'data_baseDatasetalteracao';
    data_baseDatasetalteracao.FieldName := 'alteracao';
    data_baseDatasetexclusao.SetParentComponent(data_baseDataset);
    data_baseDatasetexclusao.Name := 'data_baseDatasetexclusao';
    data_baseDatasetexclusao.FieldName := 'exclusao';
    data_baseDatasetrazao_social.SetParentComponent(data_baseDataset);
    data_baseDatasetrazao_social.Name := 'data_baseDatasetrazao_social';
    data_baseDatasetrazao_social.FieldName := 'razao_social';
    data_baseDatasetrazao_social.Size := 255;
    data_baseDatasetnome_fantasia.SetParentComponent(data_baseDataset);
    data_baseDatasetnome_fantasia.Name := 'data_baseDatasetnome_fantasia';
    data_baseDatasetnome_fantasia.FieldName := 'nome_fantasia';
    data_baseDatasetnome_fantasia.Size := 255;
    data_baseDatasethost.SetParentComponent(data_baseDataset);
    data_baseDatasethost.Name := 'data_baseDatasethost';
    data_baseDatasethost.FieldName := 'host';
    data_baseDatasethost.Size := 255;
    data_baseDatasetpath.SetParentComponent(data_baseDataset);
    data_baseDatasetpath.Name := 'data_baseDatasetpath';
    data_baseDatasetpath.FieldName := 'path';
    data_baseDatasetpath.Size := 255;
    data_baseDatasetdata_base_multiempresa.SetParentComponent(data_baseDataset);
    data_baseDatasetdata_base_multiempresa.Name := 'data_baseDatasetdata_base_multiempresa';
    data_baseDatasetdata_base_multiempresa.FieldName := 'data_base_multiempresa';
    data_baseDatasetdata_base_empresa_destino.SetParentComponent(data_baseDataset);
    data_baseDatasetdata_base_empresa_destino.Name := 'data_baseDatasetdata_base_empresa_destino';
    data_baseDatasetdata_base_empresa_destino.FieldName := 'data_base_empresa_destino';
    data_baseDatasetversao_atual.SetParentComponent(data_baseDataset);
    data_baseDatasetversao_atual.Name := 'data_baseDatasetversao_atual';
    data_baseDatasetversao_atual.FieldName := 'versao_atual';
    data_baseDatasetversao_atual.Size := 255;
    data_baseDatasetversao_pendente.SetParentComponent(data_baseDataset);
    data_baseDatasetversao_pendente.Name := 'data_baseDatasetversao_pendente';
    data_baseDatasetversao_pendente.FieldName := 'versao_pendente';
    data_baseDatasetversao_pendente.Size := 255;
    data_baseDatasetregime_contabil.SetParentComponent(data_baseDataset);
    data_baseDatasetregime_contabil.Name := 'data_baseDatasetregime_contabil';
    data_baseDatasetregime_contabil.FieldName := 'regime_contabil';
    data_baseDatasetregime_contabil.Size := 255;
    data_baseDatasetcontador_id.SetParentComponent(data_baseDataset);
    data_baseDatasetcontador_id.Name := 'data_baseDatasetcontador_id';
    data_baseDatasetcontador_id.FieldName := 'contador_id';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := data_baseDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    data_baseDataset.AfterLoadDFMValues;
    data_baseDatasetid.AfterLoadDFMValues;
    data_baseDatasettoken.AfterLoadDFMValues;
    data_baseDatasetfiscal.AfterLoadDFMValues;
    data_baseDatasetaliado_id.AfterLoadDFMValues;
    data_baseDatasetexcluido.AfterLoadDFMValues;
    data_baseDatasetinclusao.AfterLoadDFMValues;
    data_baseDatasetalteracao.AfterLoadDFMValues;
    data_baseDatasetexclusao.AfterLoadDFMValues;
    data_baseDatasetrazao_social.AfterLoadDFMValues;
    data_baseDatasetnome_fantasia.AfterLoadDFMValues;
    data_baseDatasethost.AfterLoadDFMValues;
    data_baseDatasetpath.AfterLoadDFMValues;
    data_baseDatasetdata_base_multiempresa.AfterLoadDFMValues;
    data_baseDatasetdata_base_empresa_destino.AfterLoadDFMValues;
    data_baseDatasetversao_atual.AfterLoadDFMValues;
    data_baseDatasetversao_pendente.AfterLoadDFMValues;
    data_baseDatasetregime_contabil.AfterLoadDFMValues;
    data_baseDatasetcontador_id.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
